// @flow
import * as React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import Link, { RouterLink } from 'components/Link';
import PrintHidden from 'components/PrintHidden';
import { H5 } from 'components/Text';
import Icon from 'components/Icon';
import { colors, gutterWidth, breakpoints } from '../theme';

const ToolBox = styled(Box)`
  > *:not(:first-child) {
    margin-left: 12px;
    @media (min-width: ${breakpoints[2]}) {
      margin-left: 20px;
    }
  }

  button,
  a {
    @media (min-width: ${breakpoints[1]}) {
      min-width: 120px;
    }
  }
`;

const BackRouterLink = styled(RouterLink)`
  color: white;
  &:hover,
  &:focus {
    color: white;
  }
`;

const BackLink = styled(Link)`
  color: white;
  &:hover,
  &:focus {
    color: white;
  }
`;

const PageToolbar = ({
  backLinkProps,
  backLinkText,
  message,
  tools,
  light,
  centered,
  ...props
}: {
  backLinkProps?: Object,
  backLinkText?: React.Node,
  message?: React.Node,
  tools?: React.Node,
  light?: boolean,
  centered?: boolean
}) => {
  const fullLink = backLinkProps && backLinkProps.withPageLoad;
  const LinkComponent = fullLink ? BackLink : BackRouterLink;
  return (
    <PrintHidden>
      <Box
        position="relative"
        zIndex="1"
        py="6px"
        px={gutterWidth / 2}
        display={['block', null, 'flex']}
        flexWrap="wrap"
        alignItems="center"
        justifyContent={centered ? 'center' : 'space-between'}
        bg={light ? colors.platinum : colors.waterBlue}
        color={light ? colors.waterBlue : 'white'}
        {...props}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flex="0 0 auto"
          pr={centered ? [0, null, 24] : 0}
        >
          {backLinkProps && (
            <LinkComponent {...backLinkProps}>
              <Box
                display="flex"
                alignItems="center"
                flex="1"
                justifyContent="space-between"
                pr={[12, null, null, 40]}
                mr={[12, null, null, 40]}
                borderRight={[null, null, `1px solid ${colors.white}`]}
              >
                <Box mr={[8, null, null, 16]}>
                  <Icon
                    display="block"
                    fill={colors.white}
                    height="9px"
                    name="chevron"
                    direction="left"
                    width="15px"
                  />
                </Box>
                <H5 m={0} tag="span">
                  {backLinkText}
                </H5>
              </Box>
            </LinkComponent>
          )}
          {message && (
            <H5 m={0} tag="div" textAlign={['center', null, 'left']}>
              {message}
            </H5>
          )}
        </Box>
        {tools && (
          <ToolBox
            py="6px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flex="0 0 auto"
            mt={[12, null, 0]}
          >
            {tools}
          </ToolBox>
        )}
      </Box>
    </PrintHidden>
  );
};

export default PageToolbar;
